// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body {
  font-family: Arial, Helvetica, sans-serif;
  overflow-x: hidden;
  padding: 0 !important;
  margin: 0 !important;
}

input,
textarea {
  unicode-bidi: plaintext;
}

.ant-typography,
.ant-btn > span,
.ant-form-item-label > label,
.ant-form-item-extra,
.ant-form-item-explain-error,
.ant-checkbox-wrapper > span:last-child,
.ant-radio-wrapper > span:last-child,
.ant-card-meta-title,
.ant-card-meta-description,
.ant-list-item-meta-title,
.ant-list-item-meta-description,
.ant-select-selection-item,
.ant-select-item-option-content,
.ant-tabs-tab-btn,
.ant-collapse-header-text,
.ant-modal-title,
.ant-tooltip-inner,
.ant-result-title,
.ant-result-subtitle,
.ant-statistic-title,
.ant-tag {
  unicode-bidi: plaintext;
}

#root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

#agenda,
#speakers,
#contacts {
  scroll-margin-top: var(--navbar-height-mobile);
}
@media (min-width: 1200px) {
  #agenda,
  #speakers,
  #contacts {
    scroll-margin-top: var(--navbar-height-desktop);
  }
}

.not-yet-animated {
  visibility: hidden !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/index.scss"],"names":[],"mappings":"AAEA;EACI,sBAAA;AADJ;;AAIA;EACI,yCAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;AADJ;;AAKA;;EAEI,uBAAA;AAFJ;;AAOA;;;;;;;;;;;;;;;;;;;;;EAqBI,uBAAA;AAJJ;;AAOA;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;AAJJ;;AAOA;;;EAGI,8CAAA;AAJJ;AAMI;EALJ;;;IAMQ,+CAAA;EADN;AACF;;AAIA;EACI,6BAAA;AADJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
